/* src/routes/blog/conky-config.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import Gallery from "../../../_components/Gallery.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";
import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";

function create_default_slot_9(ctx) {
	let t;

	return {
		c() {
			t = text("Conky-Colors");
		},
		l(nodes) {
			t = claim_text(nodes, "Conky-Colors");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (46:6) <LinkExternal href="https://aur.archlinux.org/packages/conky-nvidia/">
function create_default_slot_8(ctx) {
	let t;

	return {
		c() {
			t = text("conky-nvidia");
		},
		l(nodes) {
			t = claim_text(nodes, "conky-nvidia");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (50:6) <LinkExternal href="https://www.archlinux.org/packages/?name=lm_sensors">
function create_default_slot_7(ctx) {
	let t;

	return {
		c() {
			t = text("lm_sensors");
		},
		l(nodes) {
			t = claim_text(nodes, "lm_sensors");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (63:6) <LinkExternal         href="https://github.com/helmuthdu/conky_colors/tree/master/fonts/conkycolors">
function create_default_slot_6(ctx) {
	let t;

	return {
		c() {
			t = text("conky-colors TTF files");
		},
		l(nodes) {
			t = claim_text(nodes, "conky-colors TTF files");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (69:4) <Callout title="PLEASE NOTE:">
function create_default_slot_5(ctx) {
	let t;

	return {
		c() {
			t = text("I'm sure there's a better way of getting the CPU temps. Please let me know\n      if this is the case. I'm not sure that the Ethernet if else statements are\n      working correctly.");
		},
		l(nodes) {
			t = claim_text(nodes, "I'm sure there's a better way of getting the CPU temps. Please let me know\n      if this is the case. I'm not sure that the Ethernet if else statements are\n      working correctly.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (77:6) <LinkExternal         href="http://helmuthdu.deviantart.com/art/CONKY-COLORS-244793180">
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Lovely conky-colors deviant-art by helmuthdu");
		},
		l(nodes) {
			t = claim_text(nodes, "Lovely conky-colors deviant-art by helmuthdu");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (82:6) <LinkExternal href="https://github.com/helmuthdu/conky_colors">
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("helmuthdu's github conky-colors repository");
		},
		l(nodes) {
			t = claim_text(nodes, "helmuthdu's github conky-colors repository");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (75:4) <Callout title="FURTHER READING:">
function create_default_slot_2(ctx) {
	let t0;
	let linkexternal0;
	let t1;
	let linkexternal1;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "http://helmuthdu.deviantart.com/art/CONKY-COLORS-244793180",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "https://github.com/helmuthdu/conky_colors",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("There is some\n      ");
			create_component(linkexternal0.$$.fragment);
			t1 = text("\n      . Further information on this project cna be found at\n      ");
			create_component(linkexternal1.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "There is some\n      ");
			claim_component(linkexternal0.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n      . Further information on this project cna be found at\n      ");
			claim_component(linkexternal1.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal0, target, anchor);
			insert(target, t1, anchor);
			mount_component(linkexternal1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal0, detaching);
			if (detaching) detach(t1);
			destroy_component(linkexternal1, detaching);
		}
	};
}

// (31:2) <PostSection>
function create_default_slot_1(ctx) {
	let p0;
	let t0;
	let t1;
	let gallery;
	let t2;
	let p1;
	let t3;
	let linkexternal0;
	let t4;
	let linkexternal1;
	let t5;
	let linkexternal2;
	let t6;
	let t7;
	let prism;
	let t8;
	let p2;
	let strong0;
	let t9;
	let t10;
	let strong1;
	let t11;
	let t12;
	let linkexternal3;
	let t13;
	let t14;
	let callout0;
	let t15;
	let callout1;
	let current;

	gallery = new Gallery({
			props: {
				images: ["/content/blog/images/conky-config/Conky_Config.png"]
			}
		});

	linkexternal0 = new LinkExternal({
			props: {
				href: "https://aur.archlinux.org/packages/conky-colors/",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "https://aur.archlinux.org/packages/conky-nvidia/",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	linkexternal2 = new LinkExternal({
			props: {
				href: "https://www.archlinux.org/packages/?name=lm_sensors",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	prism = new Prism({
			props: {
				language: "Bash",
				code: /*gistContents*/ ctx[0]
			}
		});

	linkexternal3 = new LinkExternal({
			props: {
				href: "https://github.com/helmuthdu/conky_colors/tree/master/fonts/conkycolors",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	callout0 = new Callout({
			props: {
				title: "PLEASE NOTE:",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	callout1 = new Callout({
			props: {
				title: "FURTHER READING:",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			p0 = element("p");
			t0 = text("I have had a couple of queries regarding my conky config that can be seen\n      on my new arch desktop screenshot:");
			t1 = space();
			create_component(gallery.$$.fragment);
			t2 = space();
			p1 = element("p");
			t3 = text("In order to recreate this config you will need the\n      ");
			create_component(linkexternal0.$$.fragment);
			t4 = text("\n      ,\n      ");
			create_component(linkexternal1.$$.fragment);
			t5 = text("\n      and\n      ");
			create_component(linkexternal2.$$.fragment);
			t6 = text("\n      packages");
			t7 = text("\n    Here is the conky config file (feel free to copy as needed):\n    ");
			create_component(prism.$$.fragment);
			t8 = space();
			p2 = element("p");
			strong0 = element("strong");
			t9 = text("wlp4s0");
			t10 = text("\n      and\n      ");
			strong1 = element("strong");
			t11 = text("enp3s0f0");
			t12 = text("\n      are the network device IDS, so you will need to substitute your own. If\n      you would like to modify the icons then they can be found in the\n      ");
			create_component(linkexternal3.$$.fragment);
			t13 = text("\n      on helmuthdu's github repository");
			t14 = space();
			create_component(callout0.$$.fragment);
			t15 = space();
			create_component(callout1.$$.fragment);
		},
		l(nodes) {
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "I have had a couple of queries regarding my conky config that can be seen\n      on my new arch desktop screenshot:");
			p0_nodes.forEach(detach);
			t1 = claim_space(nodes);
			claim_component(gallery.$$.fragment, nodes);
			t2 = claim_space(nodes);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			t3 = claim_text(p1_nodes, "In order to recreate this config you will need the\n      ");
			claim_component(linkexternal0.$$.fragment, p1_nodes);
			t4 = claim_text(p1_nodes, "\n      ,\n      ");
			claim_component(linkexternal1.$$.fragment, p1_nodes);
			t5 = claim_text(p1_nodes, "\n      and\n      ");
			claim_component(linkexternal2.$$.fragment, p1_nodes);
			t6 = claim_text(p1_nodes, "\n      packages");
			p1_nodes.forEach(detach);
			t7 = claim_text(nodes, "\n    Here is the conky config file (feel free to copy as needed):\n    ");
			claim_component(prism.$$.fragment, nodes);
			t8 = claim_space(nodes);
			p2 = claim_element(nodes, "P", {});
			var p2_nodes = children(p2);
			strong0 = claim_element(p2_nodes, "STRONG", {});
			var strong0_nodes = children(strong0);
			t9 = claim_text(strong0_nodes, "wlp4s0");
			strong0_nodes.forEach(detach);
			t10 = claim_text(p2_nodes, "\n      and\n      ");
			strong1 = claim_element(p2_nodes, "STRONG", {});
			var strong1_nodes = children(strong1);
			t11 = claim_text(strong1_nodes, "enp3s0f0");
			strong1_nodes.forEach(detach);
			t12 = claim_text(p2_nodes, "\n      are the network device IDS, so you will need to substitute your own. If\n      you would like to modify the icons then they can be found in the\n      ");
			claim_component(linkexternal3.$$.fragment, p2_nodes);
			t13 = claim_text(p2_nodes, "\n      on helmuthdu's github repository");
			p2_nodes.forEach(detach);
			t14 = claim_space(nodes);
			claim_component(callout0.$$.fragment, nodes);
			t15 = claim_space(nodes);
			claim_component(callout1.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, p0, anchor);
			append(p0, t0);
			insert(target, t1, anchor);
			mount_component(gallery, target, anchor);
			insert(target, t2, anchor);
			insert(target, p1, anchor);
			append(p1, t3);
			mount_component(linkexternal0, p1, null);
			append(p1, t4);
			mount_component(linkexternal1, p1, null);
			append(p1, t5);
			mount_component(linkexternal2, p1, null);
			append(p1, t6);
			insert(target, t7, anchor);
			mount_component(prism, target, anchor);
			insert(target, t8, anchor);
			insert(target, p2, anchor);
			append(p2, strong0);
			append(strong0, t9);
			append(p2, t10);
			append(p2, strong1);
			append(strong1, t11);
			append(p2, t12);
			mount_component(linkexternal3, p2, null);
			append(p2, t13);
			insert(target, t14, anchor);
			mount_component(callout0, target, anchor);
			insert(target, t15, anchor);
			mount_component(callout1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
			const linkexternal2_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal2_changes.$$scope = { dirty, ctx };
			}

			linkexternal2.$set(linkexternal2_changes);
			const prism_changes = {};
			if (dirty & /*gistContents*/ 1) prism_changes.code = /*gistContents*/ ctx[0];
			prism.$set(prism_changes);
			const linkexternal3_changes = {};

			if (dirty & /*$$scope*/ 8) {
				linkexternal3_changes.$$scope = { dirty, ctx };
			}

			linkexternal3.$set(linkexternal3_changes);
			const callout0_changes = {};

			if (dirty & /*$$scope*/ 8) {
				callout0_changes.$$scope = { dirty, ctx };
			}

			callout0.$set(callout0_changes);
			const callout1_changes = {};

			if (dirty & /*$$scope*/ 8) {
				callout1_changes.$$scope = { dirty, ctx };
			}

			callout1.$set(callout1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(gallery.$$.fragment, local);
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			transition_in(linkexternal2.$$.fragment, local);
			transition_in(prism.$$.fragment, local);
			transition_in(linkexternal3.$$.fragment, local);
			transition_in(callout0.$$.fragment, local);
			transition_in(callout1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(gallery.$$.fragment, local);
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			transition_out(linkexternal2.$$.fragment, local);
			transition_out(prism.$$.fragment, local);
			transition_out(linkexternal3.$$.fragment, local);
			transition_out(callout0.$$.fragment, local);
			transition_out(callout1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p0);
			if (detaching) detach(t1);
			destroy_component(gallery, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(p1);
			destroy_component(linkexternal0);
			destroy_component(linkexternal1);
			destroy_component(linkexternal2);
			if (detaching) detach(t7);
			destroy_component(prism, detaching);
			if (detaching) detach(t8);
			if (detaching) detach(p2);
			destroy_component(linkexternal3);
			if (detaching) detach(t14);
			destroy_component(callout0, detaching);
			if (detaching) detach(t15);
			destroy_component(callout1, detaching);
		}
	};
}

// (30:0) <PostContents>
function create_default_slot(ctx) {
	let postsection;
	let current;

	postsection = new PostSection({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postsection.$$.fragment);
		},
		l(nodes) {
			claim_component(postsection.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postsection, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection_changes = {};

			if (dirty & /*$$scope, gistContents*/ 9) {
				postsection_changes.$$scope = { dirty, ctx };
			}

			postsection.$set(postsection_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postsection.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postsection.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postsection, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[1],
				projects: /*projects*/ ctx[2]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope, gistContents*/ 9) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

async function preload({ params, query }) {
	var url = "https://gist.githubusercontent.com/Gaweph/63d48a9c43e1b256ca8c8a9a7717fed7/raw/37e5276e3cbe53162a49b27706df5142ac92fff6/conky-config";
	let response = await this.fetch(url);
	let text = await response.text();
	let gistContents = text;
	return { gistContents };
}

const title = "Conky Config";
const date = "2014-05-05 14:44:08";

function instance($$self, $$props, $$invalidate) {
	const tags = ["config", "conky"];
	const projects = [];
	let { gistContents = "XXX" } = $$props;

	$$self.$$set = $$props => {
		if ("gistContents" in $$props) $$invalidate(0, gistContents = $$props.gistContents);
	};

	return [gistContents, tags, projects];
}

class Conky_config extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { gistContents: 0 });
	}
}

export default Conky_config;
export { preload };
//# sourceMappingURL=conky-config.svelte.js.map
